var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "App Notifications" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: {
                    title: "Notifications",
                    "sub-title": "Manage all app notifications in GreenLists",
                    "with-footer": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            [
                              _c(
                                "no-permission-wrapper",
                                {
                                  attrs: { show: !_vm.canCreateNotifications },
                                },
                                [
                                  _c(
                                    "b-btn",
                                    {
                                      attrs: {
                                        variant: "primary",
                                        disabled: !_vm.canCreateNotifications,
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.createNewNotification.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                Create New Notification\n              "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _c("admin-app-notifications-table", {
                    attrs: { notifications: _vm.notifications },
                    on: {
                      "edit-clicked": (notificationId) =>
                        _vm.editNotification(notificationId),
                      "delete-clicked": (notificationId) =>
                        _vm.deleteNotification(notificationId),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("admin-app-notification-modal", {
        attrs: {
          visible: _vm.modalVisible,
          "form-validation": _vm.notificationFormValidation,
          "form-processing": _vm.notificationFormProcessing,
          forbidden:
            (!_vm.canUpdateNotifications && !!_vm.submitNotificationId) ||
            (!_vm.canCreateNotifications && !_vm.submitNotificationId),
          deleted: _vm.submitNotificationDeleted,
        },
        on: {
          "update:visible": function ($event) {
            _vm.modalVisible = $event
          },
          submit: _vm.submitNotification,
        },
        model: {
          value: _vm.notificationFormData,
          callback: function ($$v) {
            _vm.notificationFormData = $$v
          },
          expression: "notificationFormData",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }